﻿window.OccupancyStateChangedToEnum = {};

Object.defineProperties(window.OccupancyStateChangedToEnum, {
        
    ChangeToOccupancyState_10: { value: "-10", writable: false },	// Created configuration adjustment
    ChangeToOccupancyState_9:  { value: "-9", writable: false },	// Worsened configuration adjustment	
    ChangeToOccupancyState_2:  { value: "-2", writable: false },    // Understaffing created	
    ChangeToOccupancyState_1:  { value: "-1", writable: false },    // Understaffing worsened	
    ChangeToOccupancyState1:   { value: "1", writable: false },	    // Understaffing improved	
    ChangeToOccupancyState2:   { value: "2", writable: false },	    // Understaffing solved	
    ChangeToOccupancyState9:   { value: "9", writable: false },	    // Improved configuration adjustment	
    ChangeToOccupancyState10:  { value: "10", writable: false }	    // Solved configuration adjustment	

});

Object.freeze(window.OccupancyStateChangedToEnum);